import { useEffect, useState } from "react";
import { Button, TextField, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { getApiBaseUrl, readApiJson } from "../utils/apiBase";
import { setAuthToken } from "../utils/tokenHeaders";

const apiUrl = getApiBaseUrl();

export default function TeamAdminsPanel() {
  const [admins, setAdmins] = useState([]);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);

  const loadAdmins = async () => {
    const response = await fetch(`${apiUrl}/organization/admins`, {
      headers: { Authorization: setAuthToken() },
    });
    if (!response.ok) return;
    const data = await readApiJson(response);
    setAdmins(data.teamAdmins ?? []);
  };

  useEffect(() => {
    loadAdmins();
  }, []);

  const handleAdd = async () => {
    setMessage(null);
    const response = await fetch(`${apiUrl}/organization/admins`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: setAuthToken(),
      },
      body: JSON.stringify({ login: email.trim(), role: "admin" }),
    });
    const data = await readApiJson(response);
    setMessage(data.message || data.type);
    if (response.ok) {
      setEmail("");
      loadAdmins();
    }
  };

  const handleRemove = async (login) => {
    const response = await fetch(`${apiUrl}/organization/admins`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: setAuthToken(),
      },
      body: JSON.stringify({ login }),
    });
    if (response.ok) loadAdmins();
  };

  return (
    <section className="app-profile-card app-profile-card--admins">
      <h3 className="app-profile-card__title">Администраторы компании</h3>
      <p className="app-profile-muted">
        Добавьте коллег с доступом к сценариям и аналитике. Они должны
        зарегистрироваться с указанным email.
      </p>
      <div className="app-profile-admins-form">
        <TextField
          size="small"
          placeholder="email коллеги"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
        />
        <IconButton
          size="small"
          color="primary"
          className="app-profile-admins-add"
          onClick={handleAdd}
          aria-label="Добавить администратора"
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </div>
      {message ? <p className="app-profile-muted">{message}</p> : null}
      {admins.length ? (
        <ul className="app-profile-admins-list">
          {admins.map((admin) => (
            <li key={admin.login}>
              <span>
                {admin.login} · {admin.role}
              </span>
              <Button size="small" onClick={() => handleRemove(admin.login)}>
                Удалить
              </Button>
            </li>
          ))}
        </ul>
      ) : (
        <p className="app-profile-muted">Пока только владелец аккаунта</p>
      )}
    </section>
  );
}
